import { IonSegmentCustomEvent } from '@ionic/core';
import { IonLabel, IonSegment, IonSegmentButton, SegmentChangeEventDetail } from '@ionic/react';

const MAX_TAB_WIDTH = 150;

export type ITabProps<T extends string> = {
    'data-id'?: string;
    value?: T;
    onChange?: (value: T) => void;
    fullWidth?: boolean;
    buttons: {
        label: string;
        value: T;
        hidden?: boolean;
    }[];
};

export const MDTabs = <T extends string>({ 'data-id': dataId, value, onChange, buttons, fullWidth }: ITabProps<T>) => {

    const handleChange = (e: IonSegmentCustomEvent<SegmentChangeEventDetail>) => {
        if (onChange) {
            onChange(e.detail.value as T);
        }
    };

    return (
        <IonSegment
            mode="md"
            value={value}
            data-id={dataId}
            onIonChange={handleChange}
            style={{maxWidth: fullWidth ? undefined : buttons.length * MAX_TAB_WIDTH}}
        >
            {buttons.map(button => !button.hidden && (
                <IonSegmentButton
                    key={button.value}
                    value={button.value}
                    style={{textTransform: 'none', fontWeight: 'bold'}}
                >
                    <IonLabel>
                        {button.label}
                    </IonLabel>
                </IonSegmentButton>
            ))}
        </IonSegment>
    );
};
